import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl/components/Can';
import { ReadRetailerNetworkLocations } from '@occc-app/App/PolicyBasedAccessControl/userActions';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

type RetailerNetworkLocationDetailsPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkLocationDetailsPageGuard = ({
  children,
}: RetailerNetworkLocationDetailsPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <ConfigGuard isFeatureEnabled={(config) => !!config.retailerConnect?.enabled}>
      <Can I={ReadRetailerNetworkLocations({ uuid: networkId })} fallback={<UnauthorizedPage />}>
        {children}
      </Can>
    </ConfigGuard>
  );
};
